/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index template to autogenerate all the components and extensions
 * Used by "prepareTemplates"
 */

// import all the available components
import Accordion from './accordion/Accordion'
import Anchor from './anchor/Anchor'
import AriaLive from './aria-live/AriaLive'
import Autocomplete from './autocomplete/Autocomplete'
import Avatar from './avatar/Avatar'
import Badge from './badge/Badge'
import Breadcrumb from './breadcrumb/Breadcrumb'
import Button from './button/Button'
import Card from './card/Card'
import Checkbox from './checkbox/Checkbox'
import CopyOnClick from './copy-on-click/CopyOnClick'
import CountryFlag from './country-flag/CountryFlag'
import DatePicker from './date-picker/DatePicker'
import Dialog from './dialog/Dialog'
import Drawer from './drawer/Drawer'
import Dropdown from './dropdown/Dropdown'
import Flex from './flex/Flex'
import FormLabel from './form-label/FormLabel'
import FormRow from './form-row/FormRow'
import FormSet from './form-set/FormSet'
import FormStatus from './form-status/FormStatus'
import GlobalError from './global-error/GlobalError'
import GlobalStatus from './global-status/GlobalStatus'
import Grid from './grid/Grid'
import Heading from './heading/Heading'
import HeightAnimation from './height-animation/HeightAnimation'
import HelpButton from './help-button/HelpButton'
import Icon from './icon/Icon'
import IconPrimary from './icon-primary/IconPrimary'
import InfoCard from './info-card/InfoCard'
import Input from './input/Input'
import InputMasked from './input-masked/InputMasked'
import ListFormat from './list-format/ListFormat'
import Logo from './logo/Logo'
import Modal from './modal/Modal'
import NumberFormat from './number-format/NumberFormat'
import Pagination from './pagination/Pagination'
import ProgressIndicator from './progress-indicator/ProgressIndicator'
import Radio from './radio/Radio'
import Section from './section/Section'
import Skeleton from './skeleton/Skeleton'
import SkipContent from './skip-content/SkipContent'
import Slider from './slider/Slider'
import Space from './space/Space'
import StepIndicator from './step-indicator/StepIndicator'
import Switch from './switch/Switch'
import Table from './table/Table'
import Tabs from './tabs/Tabs'
import Tag from './tag/Tag'
import Textarea from './textarea/Textarea'
import Timeline from './timeline/Timeline'
import ToggleButton from './toggle-button/ToggleButton'
import Tooltip from './tooltip/Tooltip'
import Upload from './upload/Upload'
import VisuallyHidden from './visually-hidden/VisuallyHidden'

// define / export all the available components
export {
  Accordion,
  Anchor,
  AriaLive,
  Autocomplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  CopyOnClick,
  CountryFlag,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  Flex,
  FormLabel,
  FormRow,
  FormSet,
  FormStatus,
  GlobalError,
  GlobalStatus,
  Grid,
  Heading,
  HeightAnimation,
  HelpButton,
  Icon,
  IconPrimary,
  InfoCard,
  Input,
  InputMasked,
  ListFormat,
  Logo,
  Modal,
  NumberFormat,
  Pagination,
  ProgressIndicator,
  Radio,
  Section,
  Skeleton,
  SkipContent,
  Slider,
  Space,
  StepIndicator,
  Switch,
  Table,
  Tabs,
  Tag,
  Textarea,
  Timeline,
  ToggleButton,
  Tooltip,
  Upload,
  VisuallyHidden,
}

export const getComponents = () => {
  return {
    Accordion,
    Anchor,
    AriaLive,
    Autocomplete,
    Avatar,
    Badge,
    Breadcrumb,
    Button,
    Card,
    Checkbox,
    CopyOnClick,
    CountryFlag,
    DatePicker,
    Dialog,
    Drawer,
    Dropdown,
    Flex,
    FormLabel,
    FormRow,
    FormSet,
    FormStatus,
    GlobalError,
    GlobalStatus,
    Grid,
    Heading,
    HeightAnimation,
    HelpButton,
    Icon,
    IconPrimary,
    InfoCard,
    Input,
    InputMasked,
    ListFormat,
    Logo,
    Modal,
    NumberFormat,
    Pagination,
    ProgressIndicator,
    Radio,
    Section,
    Skeleton,
    SkipContent,
    Slider,
    Space,
    StepIndicator,
    Switch,
    Table,
    Tabs,
    Tag,
    Textarea,
    Timeline,
    ToggleButton,
    Tooltip,
    Upload,
    VisuallyHidden,
  }
}
